import { Grid2, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { NotificationDataType } from "../Domain/NotificationSettings.types";
import { timeRelatedNotiTypes } from "../Domain/NotificationSettings.data";
import {
  generateDescription,
  generateTimeRelatedDescription
} from "../functions/translateNotificationName.function";

export function NotificationCardDescription({
  subject,
  time,
  isActivated,
  timeSwitches,
  handleEditTime
}: Readonly<{
  subject: NotificationDataType;
  time: number;
  isActivated: boolean;
  timeSwitches: Record<string, number> | undefined;
  handleEditTime: (subject: NotificationDataType, newValue: number) => void;
}>) {
  const { t } = useTranslation();

  const isTimeRelated = timeRelatedNotiTypes.includes(subject);
  const frontText = t("_notificationTimeRelatedSettingFrontText");
  const bodyText = generateTimeRelatedDescription(subject);

  const editTime = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const targetId = e.target.id as NotificationDataType;
    const targetValue = Number(e.target.value);

    handleEditTime(targetId, targetValue);
  };

  return (
    <>
      {!isTimeRelated && (
        <Typography variant="body2">{generateDescription(subject, time)}</Typography>
      )}

      {isTimeRelated && timeSwitches && (
        <Grid2 sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="body2">{frontText}</Typography>

          <TextField
            data-testid={`notification-setting-${subject}-time-field`}
            id={subject}
            disabled={!isActivated}
            value={timeSwitches[subject] ?? time}
            type="number"
            slotProps={{ htmlInput: { min: 0, style: { textAlign: "center" } } }}
            onChange={editTime}
            sx={{ mx: 1, width: 70 }}
          />

          <Typography variant="body2">{bodyText}</Typography>
        </Grid2>
      )}
    </>
  );
}
